'use strict';

module.exports = ['$scope', function ($scope) {

}];
